import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router';

import MenuElement from './MenuElement';

const MenuElementContainer = ({ target, ...props }) => {
  const { pathname } = useLocation();
  const isActive = pathname === target;
  return <MenuElement isActive={isActive} target={target} {...props} />;
};

MenuElementContainer.propTypes = {
  target: PropTypes.string.isRequired,
};

export default MenuElementContainer;
